import { getClientProductAssigned, postClientProdcutAssigned } from 'helpers/backend_helper';
import React, { useEffect } from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { PropTypes } from 'prop-types';

const ProductsAssigned = ({ model }) => {
    const [assignedProducts, setAssignedProducts] = React.useState([]);
    const [selectedValues, setSelectedValues] = React.useState({});
    const [btnSaveLoad, setBtnSaveLoad] = React.useState(false)

    const fetchAssignedProducts = async () => {
        getClientProductAssigned(model.id).then((data) => {
            setAssignedProducts(data);
            data.forEach((product) => {
                setSelectedValues((prev) => ({
                    ...prev,
                    [product.id]: {
                        assigned: product.assigned ? true : false,
                        max_adjustment: product.max_adjustment || 0
                    }
                }));
            })
        });
    };

    const onSubmit = async () => {
        let payload = [];
        Object.keys(selectedValues).forEach((productId) => {
            console.log(`Producto ID: ${productId}, Asignado: ${selectedValues[productId].assigned}, Cantidad de ajuste: ${selectedValues[productId].max_adjustment}`);
            if (selectedValues[productId].assigned) {
                payload.push({
                    enterprise_id: model.id,
                    product_id: productId,
                    assigned: selectedValues[productId].assigned,
                    max_adjustment: selectedValues[productId].max_adjustment
                });
            }
        });

        setBtnSaveLoad(true);
        try {
            const response = await postClientProdcutAssigned(model.id, {
                products: payload
            })
            await fetchAssignedProducts();
        } catch (error) {
            console.error("Error saving assigned products:", error);
        }
        setBtnSaveLoad(false);
    };

    useEffect(() => {
        fetchAssignedProducts();
    }, []);

    return (
        <Card>
            <CardBody>
                <table className="table table-responsive table-bordered table-sm table-striped">
                    <thead>
                        <tr className='bg-light'>
                            <th>Asignado?</th>
                            <th>Producto</th>
                            <th>Porcentaje de ajuste (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(assignedProducts || []).map((product, key) => (
                            <tr key={product?.id}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedValues?.[product.id]?.assigned ?? false}
                                        onClick={() => {
                                            setSelectedValues((prev) => ({
                                                ...prev,
                                                [product.id]: {
                                                    ...prev[product.id],
                                                    assigned: !prev[product.id]?.assigned
                                                }
                                            }));
                                        }}
                                    />
                                </td>
                                <td>{product?.name}</td>
                                <td>
                                    <input
                                        className='form-control text-end'
                                        type='number'
                                        min={0}
                                        step={1}
                                        onWheel={(e) => e.target.blur()}
                                        value={selectedValues?.[product.id]?.max_adjustment || 0}
                                        disabled={!selectedValues?.[product.id]?.assigned}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setSelectedValues((prev) => ({
                                                ...prev,
                                                [product.id]: {
                                                    ...prev[product.id],
                                                    max_adjustment: value
                                                }
                                            }));
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                        {assignedProducts?.length == 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">Sin Productos asignados</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="text-center mt-3">
                    <button
                        type="button"
                        className="btn btn-sm btn-danger w-md"
                        disabled={btnSaveLoad}
                        onClick={onSubmit}
                    >
                        <i className="fas fa-save"></i> Guardar
                    </button>
                </div>
            </CardBody>
        </Card>
    );
};

ProductsAssigned.propTypes = {
    model: PropTypes.object.isRequired,
};

export default ProductsAssigned;